import { Link } from 'react-router-dom';
import { navLinks } from './navLinks';

export default function Footer() {
  return (
    <footer className="bg-white border-t border-background-200 text-foreground-950">
      <div className="mx-auto max-w-[1280px] px-5 md:px-12 lg:px-16 pt-14 md:pt-20 pb-8">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-8">
          <Link to="/" className="text-[40px] sm:text-[56px] lg:text-[72px] leading-[0.95] font-medium tracking-[-0.03em] cursor-pointer">
            Daywell <span className="em-serif">Living</span>
          </Link>
          <nav className="flex flex-wrap gap-x-7 gap-y-3 md:pb-2" aria-label="Footer">
            {navLinks.map((l) => (
              <Link key={l.to} to={l.to} className="text-[14px] text-foreground-700 hover:text-foreground-950 transition-colors duration-200 whitespace-nowrap cursor-pointer">
                {l.label}
              </Link>
            ))}
          </nav>
        </div>
        <div className="mt-10 md:mt-14 pt-6 border-t border-background-200 flex flex-col sm:flex-row justify-between gap-2 text-[13px] text-foreground-600">
          <p>Thoughtful care, fuller living.</p>
          <p>&copy; 2026 Daywell Living</p>
        </div>
      </div>
    </footer>
  );
}